<template>
<div>
 
     <!-- Catalogos Cliente -->
        <v-menu v-if="view_costing==1 &&  menu_catalogos" bottom nav offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :title="fullWidth < 1024?'Catálogos':''" :icon="fullWidth <= 1024">
                    <v-icon>list</v-icon>
                    <span class="caption">Catálogos</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('catalogos.agentes') && view_costing==1 " to="/catalogos/agentescarga" @click.shift="openNew('/catalogos/agentescarga');">

                    <v-icon>mdi-circle-small</v-icon>Proveedores Logísticos

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('catalogos.agentes') " to="/catalogos/emisores_destinatarios" @click.shift="openNew('/catalogos/emisores_destinatarios');">

                    <v-icon>mdi-circle-small</v-icon>Emisores/Destinatarios

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('catalogos.representantes')" to="/catalogos/representantes" @click.shift="openNew('/catalogos/representantes');">

                    <v-icon>mdi-circle-small</v-icon>Representantes Legales

                </app-bar-item>

            </v-list>
        </v-menu>

        <!-- Utilerias -->
        <v-menu v-if="view_costing==1 &&  menu_utilerias" nav bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Utilerias':''" v-tippy>
                    <v-icon>dashboard</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Utilerías</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="valida_permiso('administracion.usuarios')" to="/catalogos/usuarios" @click.shift="openNew('/catalogos/usuarios');">

                    <v-icon>mdi-circle-small</v-icon>Usuarios

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administracion.aduanas') && !soloEcosting" to="/clientes/aduanas" @click.shift="openNew('/clientes/aduanas');">

                    <v-icon>mdi-circle-small</v-icon>Aduanas Cliente

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administracion.apendices') && !soloEcosting" to="/apendices/24" @click.shift="openNew('/apendices/24');">

                    <v-icon>mdi-circle-small</v-icon>Apéndices

                </app-bar-item>

                <app-bar-item v-if="valida_permiso('administracion.accesos')" to="/catalogos/acceso_usuarios" @click.shift="openNew('/catalogos/acceso_usuarios');">

                    <v-icon>mdi-circle-small</v-icon>Log de Accesos

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('administracion.enotes')" to="/catalogos/enotes" @click.shift="openNew('/catalogos/enotes');">

                    <v-icon>mdi-circle-small</v-icon>eNotes

                </app-bar-item>

               
            </v-list>
        </v-menu>


        <!-- costing-->
        <v-menu v-if="view_costing==1 && !is_consignatario && !es_transportista " bottom offset-y origin="center center" nav transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Reportes':''" v-tippy>
                    <v-icon>mdi-cash-multiple</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">eCosting</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                <app-bar-item v-if="view_costing==1 " to="/facturastransito" @click.shift="openNew('/facturastransito');">
                    <v-icon>mdi-circle-small</v-icon>Facturas en Tránsito
                </app-bar-item>
                <app-bar-item v-if="view_costing==1 && !soloEcosting" to="/ecosting/referencia-pedimento" @click.shift="openNew('/ecosting/referencia-pedimento');">
                    <v-icon>mdi-circle-small</v-icon>Referencia Pedimento
                </app-bar-item>
                <app-bar-item v-if="view_costing==1 && !soloEcosting" to="/facturas_expediente" @click.shift="openNew('/facturas_expediente');">
                    <v-icon>mdi-circle-small</v-icon>Integración a Expediente
                </app-bar-item>

                <v-divider v-if="view_costing==1 && !soloEcosting" />
                <app-bar-item v-if="view_costing==1 && !soloEcosting" disabled>
                    <v-icon>mdi-circle-small</v-icon>Cargar Valores Incrementables
                </app-bar-item>

            </v-list>
        </v-menu>

        <!-- Reportes -->
        <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="view_costing==1 ">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Reportes':''" v-tippy>
                    <v-icon>file_copy</v-icon>
                    <span class="caption" v-show="fullWidth > 1024">Reportes</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

               
                <app-bar-item v-if="view_trafico==0 && view_costing==1" to="/panel_ecosting" @click.shift="openNew('/panel_ecosting');">

                    <v-icon>mdi-circle-small</v-icon>Reporte de Facturas

                </app-bar-item>
                <app-bar-item v-if="valida_permiso('Reportes.Logistica.reporte.facturas') && view_trafico==0 && view_costing==1" to="/pedimento_uuid" @click.shift="openNew('/pedimento_uuid');">

                    <v-icon>mdi-circle-small</v-icon>Reporte Pedimento - UUID

                </app-bar-item>
               
                <v-divider v-if="is_cliente" />
                <app-bar-item v-if="!Admin" to="/catalogos/etipsHTML" @click.shift="openNew('/catalogos/etipsHTML');">
                    <v-icon>mdi-circle-small</v-icon>Manual de Usuario
                </app-bar-item>
           
                <app-bar-item v-if="!Admin" to="/videotutorial" @click.shift="openNew('/videotutorial');">

                    <v-icon>mdi-circle-small</v-icon>Video Tutoriales

                </app-bar-item>

            </v-list>
        </v-menu>

       

      
</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";

import Util from "@/util";


export default {
    name: "menuEcosting",


    created() {

      

    },
    components: {
        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
        view_trafico() {
            return this.$store.state.trafico;
        },
        view_costing() {
            return this.$store.state.costing;
        },
        view_emanifiesto() {
            return this.$store.state.emanifiesto;
        },
        view_carta_porte() {
            return this.$store.state.carta_porte;
        },
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        soloEcosting() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100 && this.$local_storage.get("Modulo18") != 100;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100  &&
                this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") == 100 || this.$local_storage.get("EmanifiestoMV.Logistica.bitacora") == 100) 
                && this.$local_storage.get("Modulo18") != 100;
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista")==1 ;
        },
        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo"); ;
        },
        Admin() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                this.$local_storage.get("id_cliente") == 0
            );
        },
      
   
        menu_catalogos() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                  (  this.valida_permiso("catalogos.agentes") ||
                    this.valida_permiso("catalogos.representantes") 
                ) && this.view_emanifiesto == 0 && this.view_carta_porte == 0
            );
        },
        menu_utilerias() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("administracion.usuarios") ||
                    this.valida_permiso("administracion.aduanas") ||
                    this.valida_permiso("administracion.apendices") ||
                    this.valida_permiso("administracion.accesos") ||
                    this.valida_permiso("administracion.enotes") 
                ) && this.view_emanifiesto == 0 && this.view_carta_porte == 0
            );
        },
        
        is_consignatario() {
            return this.$local_storage.get("perfil_grupo") == 43;
        },
       
        is_cliente() {
            return (
                this.$local_storage.get("id_cliente") > 0
            );
        },
       
        esGrupo(){
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        valida_permiso_t(permiso) {
            return (
                this.$local_storage.get(permiso) == 100
            );
        },
       
        handleFullScreen() {
            Util.toggleFullScreen();
        },

       
        openNew: function (h) {
            window.open(h, "_blank");
        },
       


       
        
    },
  
};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
